export default __webpack_public_path__ + "static/media/LoadingBars.9470026b.svg";